import React, { FC, useState } from "react";
import cn from "classnames";
import { IChat } from "src/@types/chat";
import { IMessage } from "src/@types/message";
import { MessageInfo } from "./MessageInfo";
import { AddMessage } from "./AddMessage";
import { MessagesList } from "./MessagesList";

interface Props {
  className?: string;
  chat: IChat;
}

export const ChatWindow: FC<Props> = ({ className, chat }) => {
  const { id, title, messages: messagesChat, image } = chat;

  const [messages, setMessages] = useState<IMessage[]>(messagesChat);

  const addMessage = (newMessage: IMessage) => {
    setMessages((prevMessages) => [...prevMessages, newMessage]);
  };

  return (
    <div
      className={cn(
        "flex flex-col gap-3 md:gap-5 flex-1 p-3 md:p-5 bg-purple-lighter rounded-20",
        className
      )}
    >
      <MessageInfo title={title} image={image} />
      <MessagesList messages={messages} />
      <AddMessage chatId={id} addMessage={addMessage} />
    </div>
  );
};
